module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft-b1c51d48cdd8107562df8776cebc6c6e.png";